import React from 'react';
import { IonButton, IonRow } from '@ionic/react';
import Icon from 'src/components/Icon';

const PaginationBtns = (props) => {
  const { paginate = 10, total, goToPage, page = 1, forceShow } = props;
  const lastOfSet = page * paginate;
  const firstOfSet = lastOfSet - (paginate - 1);
  const show = forceShow === true ? true : total > paginate;

  return show ? (
    <IonRow className="ion-row ion-padding ion-align-items-center ion-justify-content-end">
      <span className="ion-margin-end">
        {firstOfSet} - {lastOfSet > total ? total : lastOfSet}&nbsp; of&nbsp;
        {total}
      </span>
      <IonButton
        color="light"
        className="ion-margin-end"
        disabled={Number(page) === 1}
        onClick={() => goToPage(Number(page) - 1)}
      >
        <Icon type="arrow-left" />
      </IonButton>
      <IonButton
        color="light"
        disabled={lastOfSet > total ? true : false}
        onClick={() => goToPage(Number(page) + 1)}
      >
        <Icon type="arrow-right" />
      </IonButton>
    </IonRow>
  ) : null;
};

export default PaginationBtns;
